import React from "react";

export const MultiplayerPanel: React.FC = () => {
  return (
    <div className="stack-v stack-v--gap-md">
      <header className="stack-v stack-v--gap-xs">
        <div className="text-xs text-muted" style={{ textTransform: "uppercase", letterSpacing: "0.08em" }}>
          Friends mode
        </div>
        <div className="stack-h stack-h--gap-sm" style={{ alignItems: "baseline" }}>
          <span className="text-lg" style={{ fontWeight: 600 }}>
            Multiplayer coming next
          </span>
          <span className="pill pill--accent text-xs">lobby preview</span>
        </div>
      </header>

      <p className="text-sm text-muted">
        You&apos;ll be able to create a room, ready up with friends, and race to complete the same
        puzzle. This panel will also show live progress and final rankings.
      </p>

      <div className="stack-v stack-v--gap-sm">
        <button className="btn btn--primary" type="button" disabled>
          Create room
        </button>
        <button className="btn btn--ghost" type="button" disabled>
          Join with code
        </button>
      </div>

      <div className="stack-v stack-v--gap-xs">
        <span className="text-xs text-muted">What will sync between players?</span>
        <ul className="text-xs text-muted" style={{ paddingLeft: "1rem", margin: 0 }}>
          <li>Same image and tile layout</li>
          <li>Shared countdown and start time</li>
          <li>Individual move counts and completion times</li>
        </ul>
      </div>
    </div>
  );
};


